import { apiFetch } from './client'

export type BewegungsQuelle = 'dr' | 'lager' | 'packstation' | 'packplatz' | 'nullmengen'
export interface ArtikelBewegung {
  id: number; zeit: string; quelle: BewegungsQuelle; art: string; art_label: string
  menge: number | null; delta: number | null; vorher: number | null; nachher: number | null
  wer: string | null; geraet: string | null; platz: string | null; notiz: string | null; lager_move_id: number | null
}
export interface ArtikelBewegungenSeite {
  data: ArtikelBewegung[]
  next_cursor: string | null
  quellen: BewegungsQuelle[]
  facets: { arten: Array<{ wert: string; label: string }>; wer: string[]; geraete: string[] }
}
export interface BewegungenFilter {
  quelle: BewegungsQuelle[]; art?: string; wer?: string; geraet?: string; von?: string; bis?: string; cursor?: string
}
export function getArtikelBewegungen(key: string, filter: BewegungenFilter): Promise<ArtikelBewegungenSeite> {
  const q = new URLSearchParams({ company: 'stahlia', quelle: filter.quelle.join(','), limit: '50' })
  for (const name of ['art', 'wer', 'geraet', 'von', 'bis', 'cursor'] as const) if (filter[name]) q.set(name, filter[name])
  return apiFetch(`/warehouse/artikel/${encodeURIComponent(key)}/bewegungen/?${q}`)
}
